import { useQuery } from '@tanstack/react-query';
import { getReferralStats } from '@cobu/api-client';
import { ReferralStats } from '@cobu/types';

interface UseReferralStatsReturn {
  referralStats: ReferralStats | undefined;
  isLoading: boolean;
  error: Error | null;
  refetch: () => void;
}

export const useReferralStats = (): UseReferralStatsReturn => {
  const {
    data: referralStats,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['referralStats'],
    queryFn: () => getReferralStats(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 3,
  });

  return {
    referralStats,
    isLoading,
    error,
    refetch,
  };
}; 